<template>
    <div>
        <v-dialog v-model="LoginDialog" persistent max-width="580px">
        <v-card elevation="24" class="border-radius" color="#FEB033">
            <v-alert :value="alert" :type="message.type" dismissible>{{ message.texte }}</v-alert>
            <v-tabs class="tabs" color="transparent" slider-color="#FEB033" grow>

                <v-tab class="swith-click switchbutton active" @click="RegisterIntention()"
                    style="border-top-right-radius: 20px;border-top-left-radius: 20px">
                    {{ $t('login.stepper_title.inscription') }}
                </v-tab>
                <v-btn icon class="float-lg-right" @click="closeModalRegister()"
                    style="position: fixed;float:right;margin-left: 90%;color:rgba(51,51,51,0.5)">
                    <v-icon>&#xe5cd;</v-icon>
                </v-btn>
              
               <v-tab-item>
                   <div v-responsive.lg.xl>
                        <v-card flat class="text-center row"
                            style="background:#FEB033;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px">
                            <v-card-text>
                                <v-flex>
                                    <ul>
                                        <v-form v-show="!createdAcount" class="georgia">
                                            <div class="container">
                                                <form id="contact" action="" method="post">
                                                    <fieldset>
                                                        <v-radio-group class="justify-content-center row"
                                                            v-model="userRegister.genre" row
                                                            style="margin-bottom:-15px;font-family: Helvetica,Arial,sans-serif;font-size: 12px">
                                                            <v-radio color="#000000"
                                                                :label="$t('login.inscription_form.madame')"
                                                                value="femme"></v-radio>
                                                            <v-radio class="ml-3" color="#000000"
                                                                :label="$t('login.inscription_form.monsieur')"
                                                                value="homme"></v-radio>
                                                            <v-radio class="ml-3" color="#000000"
                                                                :label="$t('login.inscription_form.entreprise')"
                                                                value="entreprise"></v-radio>
                                                        </v-radio-group>
                                                    </fieldset>
                                                    <fieldset class="justify-content-center row">
                                                        <input :placeholder="$t('login.inscription_form.prenom')"
                                                            type="text" maxlength="50" v-model="userRegister.prenom"
                                                            tabindex="1" required style="width:47%!important">
                                                        <input class="ml-4"
                                                            :placeholder="$t('login.inscription_form.nom')" type="text"
                                                            maxlength="50" v-model="userRegister.nom" tabindex="2"
                                                            required style="width:47%!important">
                                                    </fieldset>
                                                    <fieldset>
                                                        <div id="error">{{ errors.name }}</div>
                                                    </fieldset>

                                                    <fieldset class="justify-content-center row">
                                                                <input :placeholder="$t('login.inscription_form.email')" type="email" maxlength="256" v-model="userRegister.email" tabindex="3" required autofocus style="width:47%!important">
                                                                <div class="ml-4" style="display: flex; align-items: center; width: 47%;">
                                                                    <select v-model="userRegister.countryCode" class="intl_number">
                                                                        <option v-for="item in intlNumberData" :key="item" :value="item.code">
                                                                            {{ item.flag }} {{ item.code }} <span v-if="selectOpen" class="select-helper">{{item.country}}</span>
                                                                        </option>
                                                                    </select>
                                                                    <span style="margin-left: -20px;margin-top: -5px; pointer-events: none; color: black; font-size: 10px;">&#9660;</span>
                                                                    <input
                                                                    :placeholder="$t('login.inscription_form.telephone')"
                                                                    type="number"
                                                                    maxlength="20"
                                                                    v-model="userRegister.telephone"
                                                                    tabindex="4"
                                                                    required
                                                                    style="border-radius: 0 30px 30px 0; border-left: none; height: 40px; background: #F99B00; color: black;"
                                                                    >
                                                                </div>
                                                                <!-- <input ref="phoneInput" id="mobile_code" class="ml-4" @keypress="onlyNumber" maxlength="256" :placeholder="$t('login.inscription_form.telephone')" type="number" v-model="userRegister.telephone" tabindex="4" required style="width:47%!important"> -->
                                                            </fieldset>

                                                    <!-- <fieldset class="justify-content-center row">
                                                        <input :placeholder="$t('login.inscription_form.email')"
                                                            type="email" maxlength="256" v-model="userRegister.email"
                                                            tabindex="3" required autofocus style="width:47%!important">
                                                        <input class="ml-4" @keypress="onlyNumber" maxlength="256"
                                                            :placeholder="$t('login.inscription_form.telephone')"
                                                            type="number" v-model="userRegister.telephone" tabindex="4"
                                                            required style="width:47%!important">
                                                    </fieldset> -->
                                                    <fieldset class="row">
                                                        <div id="error">{{ errors.email }}</div>
                                                        <div class="mt-1" id="error">{{ errors.phone }}</div>
                                                    </fieldset>

                                                    <fieldset class="justify-content-center row">
                                                        <input :placeholder="$t('login.inscription_form.password')"
                                                            maxlength="50" type="password"
                                                            v-model="userRegister.password" tabindex="5" required
                                                            style="width:47%!important">
                                                        <input class="ml-4"
                                                            :placeholder="$t('login.inscription_form.confirm_password')"
                                                            maxlength="50" type="password"
                                                            v-model="userRegister.confirmPass" tabindex="6" required
                                                            style="width:47%!important">
                                                    </fieldset>
                                                    <fieldset>
                                                        <div id="error">{{ errors.password }}</div>
                                                    </fieldset>
                                                    <fieldset class="row">
                                                        <label style="margin-top: 12px;" class="ml-2 container-checkbox">
                                                            {{$t('login.inscription_form.code_parrainge_label') }}
                                                        <input disabled type="checkbox" v-model="checkbox_code">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                        <input readonly placeholder="Entrer le code de votre parrain" maxlength="50" type="text" v-model="code_parrain" tabindex="6" required style="width:47%!important;margin-left: 25px !important;">
                                                    </fieldset>
                                                    <label class="ml-2 container-checkbox">{{
                                                        $t('login.inscription_form.condition[0]') }}
                                                        <span style="text-decoration:underline"><a
                                                                style="color: #000000" href="/info/legale"
                                                                target="_blank">{{
                                                                    $t('login.inscription_form.condition[1]') }}</a></span>
                                                        {{ $t('login.inscription_form.condition[2]') }} <span
                                                            style="text-decoration:underline"><a style="color: #000000"
                                                                href="/condition/generale" target="_blank">{{
                                                                    $t('login.inscription_form.condition[3]') }}</a></span>
                                                        {{ $t('login.inscription_form.condition[4]') }}
                                                        <input type="checkbox" value="accepted"
                                                            v-model="acceptedCondition">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <label class="ml-2 container-checkbox">
                                                        {{ $t('login.inscription_form.newsletter') }}
                                                        <input v-model="newsletter" type="checkbox">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                
                                                    <!-- <fieldset class="pb-2">
                                                        <input readonly v-model="code_parrain" type="text">
                                                    </fieldset> -->

                                                    <fieldset>
                                                        <div id="error">{{ errors.code_parrain }}</div>
                                                    </fieldset>
                                                    <fieldset>
                                                        <v-btn class="mt-3" id="contact button"
                                                            @click="registerControl">{{
                                                                $t('login.inscription_form.bouton_inscription') }}</v-btn>
                                                    </fieldset>


                                                </form>
                                            </div>
                                        </v-form>
                                    </ul>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </div>

                    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
                    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                    <!-- ========================================================================================= -->
                    <div v-responsive.sm.xs>
                        <v-card flat class="text-center row"
                            style="background:#FEB033;border-bottom-left-radius: 20px;border-bottom-right-radius: 20px">
                            <v-card-text>
                                <v-flex>
                                    <ul>
                                        <v-form v-show="!createdAcount" class="georgia">
                                            <div class="container">
                                                <form id="contact" action="" method="post">
                                                    <fieldset>
                                                        <v-radio-group v-model="userRegister.genre" row
                                                            style="margin-bottom:-15px;font-family: Helvetica,Arial,sans-serif;font-size: 08px">
                                                            <v-radio class="ml-2" color="#000000"
                                                                :label="$t('login.inscription_form.madame')"
                                                                value="Femme"></v-radio>
                                                            <v-radio class="text-center ml-2" color="#000000"
                                                                :label="$t('login.inscription_form.monsieur')"
                                                                value="Homme"></v-radio>
                                                            <v-radio class="ml-2" color="#000000"
                                                                :label="$t('login.inscription_form.entreprise')"
                                                                value="entreprise"></v-radio>
                                                        </v-radio-group>
                                                    </fieldset>
                                                    <fieldset>
                                                        <input :placeholder="$t('login.inscription_form.prenom')"
                                                            type="text" maxlength="50" v-model="userRegister.prenom"
                                                            tabindex="1" required>
                                                    </fieldset>
                                                    <fieldset>
                                                        <div id="error">{{ errors.name }}</div>
                                                    </fieldset>
                                                    <fieldset>
                                                        <input :placeholder="$t('login.inscription_form.nom')"
                                                            type="text" maxlength="50" v-model="userRegister.nom"
                                                            tabindex="2" required>
                                                    </fieldset>
                                                    <fieldset>
                                                        <div id="error">{{ errors.name }}</div>
                                                    </fieldset>
                                                    <fieldset>
                                                        <input :placeholder="$t('login.inscription_form.email')"
                                                            type="email" maxlength="256" v-model="userRegister.email"
                                                            tabindex="3" required autofocus>
                                                    </fieldset>
                                                    <fieldset>
                                                        <div id="error">{{ errors.email }}</div>
                                                    </fieldset>
                                                     <fieldset class="justify-content-center row">
                                                                <div style="display: flex; align-items: center;width: 100%!important;">
                                                                    <select v-model="userRegister.countryCode" class="intl_number_mobile">
                                                                        <option v-for="item in intlNumberData" :key="item" :value="item.code">
                                                                            {{ item.flag }} {{ item.code }} <span v-if="selectOpen" class="select-helper">{{item.country}}</span>
                                                                        </option>
                                                                    </select>
                                                                    <span style="margin-left: -15px;margin-top: -5px; pointer-events: none; color: black; font-size: 8px;">&#9660;</span>
                                                                    <input
                                                                    :placeholder="$t('login.inscription_form.telephone')"
                                                                    type="number"
                                                                    maxlength="20"
                                                                    v-model="userRegister.telephone"
                                                                    tabindex="4"
                                                                    required
                                                                    style="border-radius: 0 30px 30px 0; border-left: none; background: #F99B00; color: black;"
                                                                    >
                                                                </div>
                                                                <!-- <input ref="phoneInput" id="mobile_code" class="ml-4" @keypress="onlyNumber" maxlength="256" :placeholder="$t('login.inscription_form.telephone')" type="number" v-model="userRegister.telephone" tabindex="4" required style="width:47%!important"> -->
                                                            </fieldset>
                                                    <!-- <fieldset>
                                                        <input @keypress="onlyNumber" maxlength="256"
                                                            :placeholder="$t('login.inscription_form.telephone')"
                                                            type="number" v-model="userRegister.telephone" tabindex="4"
                                                            required>
                                                    </fieldset> -->
                                                    <fieldset>
                                                        <div id="error">{{ errors.phone }}</div>
                                                    </fieldset>
                                                    <fieldset>
                                                        <input :placeholder="$t('login.inscription_form.password')"
                                                            maxlength="50" type="password"
                                                            v-model="userRegister.password" tabindex="5" required>
                                                    </fieldset>
                                                    <fieldset>
                                                        <div id="error">{{ errors.password }}</div>
                                                    </fieldset>
                                                    <fieldset class="pb-2">
                                                        <input
                                                            :placeholder="$t('login.inscription_form.confirm_password_mobile')"
                                                            maxlength="50" type="password"
                                                            v-model="userRegister.confirmPass" tabindex="6" required>
                                                    </fieldset>
                                                    <label class="ml-2 container-checkbox">{{
                                                        $t('login.inscription_form.condition[0]') }}
                                                        <span style="text-decoration:underline"><a
                                                                style="color: #000000" href="/info/legale"
                                                                target="_blank">{{
                                                                    $t('login.inscription_form.condition[1]') }}</a></span>
                                                        {{ $t('login.inscription_form.condition[2]') }} <span
                                                            style="text-decoration:underline"><a style="color: #000000"
                                                                href="/condition/generale" target="_blank">{{
                                                                    $t('login.inscription_form.condition[3]') }}</a></span>
                                                        {{ $t('login.inscription_form.condition[4]') }}
                                                        <input type="checkbox" value="accepted"
                                                            v-model="acceptedCondition">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <label class="ml-2 container-checkbox">
                                                        {{ $t('login.inscription_form.newsletter') }}
                                                        <input type="checkbox">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                   
                                                    <fieldset class="pb-2">
                                                        <input readonly v-model="code_parrain" type="text">
                                                    </fieldset>

                                                    <fieldset class="pt-3">
                                                        <v-btn id="contact button" @click="registerControl">{{
                                                            $t('login.inscription_form.bouton_inscription') }}</v-btn>
                                                    </fieldset>
                                                </form>
                                            </div>
                                        </v-form>
                                    </ul>
                                </v-flex>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-tab-item>
            </v-tabs>
        </v-card>

       
        </v-dialog>

         <!-- ================================================================================================ -->
         <v-dialog v-model="accountValidationDialog" persistent max-width="600px">
            <v-card elevation="24" class="border-radius georgia" style="background:#FEB033">
                <v-layout class="justify-content-center column">
                    <v-flex row>
                        <div class="container">
                            <div id="contact">
                                <fieldset class="mt-3"></fieldset>
                                <fieldset class="mt-3">
                                    Renseignez le code reçu par SMS
                                    <input placeholder="Votre code de validation" maxlength="256" type="text"
                                        v-model="account_validation_code" required>
                                </fieldset>
                                <fieldset>
                                    <p v-if="indication == true">Demandez un nouveau code dans {{ second_counter }}
                                        sécondes
                                        !</p>
                                    <a href="javascript: void(0)" v-if="resend_code_ctlr" @click="resend_new_code()"> Renvoyer un nouveau
                                        code</a>
                                </fieldset>
                                <fieldset class="justify-content-center row">
                                    <v-btn id="contact button" @click="user_validation()">Valider</v-btn>
                                </fieldset>
                            </div>

                        </div>

                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
        
    </div>
</template>

<script>
'use strict';
import AuthService from './../../services/AuthenticationService'
import Api from './../../services/Api'
import PushInDataLayer from '../../services/TagManager'
import store from "./../../store/store";
import RoleService from '../../services/roles.service'
import dayjs from 'dayjs'
import { mapState } from "vuex";
import ApiBrevo from '../../services/ApiBrevo';

import IntlNumber from '../../common/intlNumber.json'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const validatePhoneWithIndicatif = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valid: true, error: null };
        }
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    } catch (e) {
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    }
};


const validateName = name => {
    if (!name.length) {
        return { valid: false, error: "Le nom et le prénom sont obligatoires" };
    }
    return { valid: true, error: null };
};
const validateEmail = email => {
    if (!email.length) {
        return { valid: false, error: "L'adresse mail est obligatoire!" };
    } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
        return { valid: false, error: "Veuillez entrer un email valide!" };
    } else {
        return { valid: true, error: null };
    }
};

const validateLoginEmail = email => {
    if (!email.length) {
        return { valid: false, error: "L'adresse mail ou le numéro de téléphone est obligatoire!" };
    } else {
        return { valid: true, error: null };
    }
};

const validatePassword = password => {
    if (!password.length) {
        return { valid: false, error: "Le mot de passe est obligatoire !" };
    } else if (password.length < 15) {
        return { valid: false, error: "Le mot de passe doit contenir 15 caractères au minimum !" };
    } else {
        return { valid: true, error: null };
    }
};

const validateLoginPassword = password => {
    if (!password.length) {
        return { valid: false, error: "Le mot de passe est obligatoire !" };
    } else {
        return { valid: true, error: null };
    }
};

export default {

    name: 'Login',
    data() {

        return {
            intlNumberData: IntlNumber,
            checkbox_code: true,
            newsletter: null,
            magiclinkAuthPopupModel: false,
            user_requester_email: "",
            accountValidationDialog: false,
            account_validation_code: null,
            acceptedCondition: null,
            resend_code_ctlr: false,
            second_counter: 30,
            validation_attemp: 0,
            indication: false,
            timerInterval: null,
            createduser: null,

            partnerList: null,
            userRole: "",
            username: "",
            ENV: 'prod',
            show: '0',
            userContratCount: null,
            UserDevisCount: null,
            valid: null,
            success: false,
            errors: {},
            model: 'I\'m a text field',
            label: 'Hey!',
            hint: 'Customize me!',
            placeholder: '',
            outlined: true,
            rounded: true,
            solo: false,
            createdAcount: false,
            recoveryPassword: false,
            ServerRep: null,
            step: 0,
            password_new: null,
            alert: false,
            message: {
                type: null,
                texte: null
            },
            ToastTabSucess: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'success',
                className: 'custom-success-class'
            }, // Customized options for success toast
            ToastTabError: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 5000,
                fitToScreen: true,
                type: 'error'
            }, // Customized options for error toast
            userLogin: {
                email: '',
                password: '',
                remember_me: false,
                code_partenaire: process.env.VUE_APP_CODEP //'LOK839',//
                //code_partenaire : 'ASS381'
            },
            userRegister: {
                genre: null,
                email: '',
                password: '',
                confirmPass: '',
                telephone: '',
                nom: '',
                prenom: '',
                code_parrain: '',
                countryCode: '+221'
            },
            route_array: [
                '/devis/micro/sunuvie',
                '/devis/mrp',
                '/devis/trc/',
                '/devis/sante/assurcare',
                '/devis/sunuassur',
                '/devis/nsiaetudes',
                '/devis/sonac/caution',
                '/devis/voyage',
                '/devis/auto',
                '/devis/habitation',
                '/sante/nest',
                '/sante/nest/',
                '/sante/transvie/Entreprise',
                '/sante/transvie/individuel',
                '/sante/kermel/famille',
                '/sante/kermel/suivi',
                '/individuel',
                '/n/*'
            ]
        }
    },
    props: ['visible', 'code_parrain'],

    computed: {
        LoginDialog: {
            get() {
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        ...mapState(["roles"]),
    },

    watch: {
        ServerRep() {
            if (this.ServerRep == 200) {
                this.$toasted.show('Un lien vous a été envoyé par mail pour mettre à jour votre mot de passe !', this.ToastTabSucess);
                this.recoveryPassword = false
            } else {
                this.$toasted.show('Le lien de modification n\'a pas pu être envoyé!', this.ToastTabError)
            }
        },

    },

    methods: {
        closeModalRegister() {
            this.LoginDialog = false, 
            this.$router.push('/')
        },
        checkNewsletter() {
            let newAbonne221 = {
                listIds: [23],
                email: this.userRegister.email,
                updateEnabled: false
            }

            ApiBrevo().post('contacts', newAbonne221)
                .then(result => {
                }).catch((err) => {
                    console.log("err==== ", err)
                });
        },
        async user_magiclink_request_control() {
            this.errors = {}
            const validEmail = validateEmail(this.user_requester_email);
            this.errors.email = validEmail.error;


            if (validEmail.valid == true) {
                await this.user_magiclink_request()
            }
        },

        async user_magiclink_request() {
            if (this.user_requester_email != "") {
                Api().post("user/magiclink/request/", { email: this.user_requester_email })
                    .then(response => {
                        if (response.data.ok == 1) {
                            this.$toasted.show(response.data.msg, this.ToastTabSucess)
                            this.magiclinkAuthPopupModel = false
                        } else {
                            this.$toasted.show(response.data.msg, this.ToastTabError)
                        }
                    }).catch(err => {
                        this.$toasted.show("Aucun utilisateur trouvé avec cette adresse e-mail.", this.ToastTabError)
                    })
            } else {
                this.$toasted.show("Veuillez remplir tous les champs obligatoires. ", this.ToastTabError)
            }
        },

        fetchEventsList() {
            this.second_counter = this.second_counter - 1;
            if (this.second_counter == 0) {
                this.resend_code_ctlr = true
                this.indication = false
                clearInterval(this.timerInterval);
            }
        },

        getListPartner() {
            Api().get('partenaires/all')
                .then(resultat => {
                    this.partnerList = resultat.data.partenaires
                });
        },

        RegisterIntention() {
            const val = {
                position: this.$loginPopupPosition.position,
                event: 'sign_up_intent'
            }
            PushInDataLayer(val)
        },

        isMobile: function () {
            if (screen.width <= 760) {
                return true
            } else {
                return false
            }
        },

        isDesktop: function () {
            if (screen.width > 768) {
                return true
            } else {
                return false
            }
        },

        /*============= Fontion qui controle les champs si okay avant de se loger ===========*/
        loginControl() {
            this.errors = {}
            const validEmail = validateLoginEmail(this.userLogin.email);
            this.errors.email = validEmail.error;

            const validPassword = validateLoginPassword(this.userLogin.password)
            this.errors.password = validPassword.error

            if (validEmail.valid == true && validPassword.valid == true) {
                this.login()
            }
        },

        async registerControl() {
            this.errors = {}
            const validEmail = validateEmail(this.userRegister.email);
            this.errors.email = validEmail.error;

            const validPassword = validatePassword(this.userRegister.password)
            this.errors.password = validPassword.error

            const validName = validateName(this.userRegister.prenom && this.userRegister.nom);
            this.errors.name = validName.error;

            //const validPhone = validatePhone(this.userRegister.telephone);
            const validPhone = validatePhoneWithIndicatif(this.userRegister.telephone, this.userRegister.countryCode);
            this.errors.phone = validPhone.error;

            if (validEmail.valid == true && validPassword.valid == true) {
                if (validPhone.valid == true) {
                    await this.register()
                }
            }
        },

        passwordResetControl() {
            this.errors = {}
            const validEmail = validateEmail(this.password_new);
            this.errors.email = validEmail.error;

            if (validEmail.valid == true) {
                this.userUpdatePassword()
            }
        },

        /*=============Filtre sans le + sur le input telephone de la creation de compte ===========*/
        onlyNumber($event) {
            let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
            if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                $event.preventDefault();
            }
        },

        /*=============Login de l'utilisateur ===========*/
        async login() {
            const loginResp = await AuthService.login({
                login: this.userLogin.email,
                password: this.userLogin.password,
                code_partenaire: process.env.VUE_APP_CODEP
            }).catch((err) => {
                if (err) {
                    // Message de l'API en priorite : il distingue un mot de passe faux
                    // d'un mot de passe a renouveler (trop court ou expire).
                    const data = (err.response && err.response.data) || {};
                    this.alert = true;
                    this.message.type = 'error';
                    this.message.texte = data.msg || data.message || 'Identifiant(s) incorrect(s)';
                    this.userLogin.password = ''
                    setTimeout(() => {
                        this.alert = false;
                    }, 6000)
                }
            });
            // Connexion refusee : le message est deja affiche, rien a traiter.
            if (!loginResp) return;

            await this.$store.dispatch('setToken', loginResp.data);
            await this.$store.dispatch('setUser', loginResp.data);
            const rememberMe = this.userLogin.remember_me;
            const rememberEmail = this.userLogin.email;
            this.userLogin = {};
            this.LoginDialog = false;

            await this.onMyDevis()
            await this.getuserContrat()

            if (rememberMe) {
                this.SetCookiesRememberMe({ email: rememberEmail })
            } else {
                this.RemoveRememberMeCookie()
            }

            if (this.$loginPopupPosition.event == null && this.$loginPopupPosition.position != null) {
                this.$loginPopupPosition.event = 'login'
                PushInDataLayer(this.$loginPopupPosition)
            } else if (this.$loginPopupPosition.event != null && this.$loginPopupPosition.position != null) {
                PushInDataLayer(this.$loginPopupPosition)
            }

         


            await this.$store.dispatch('setDevis', null);
            await this.$store.dispatch('setDevisPayement', null);
            await this.$store.dispatch('setDevisPayementDiffere', null);
            await this.$store.dispatch('setNewcontrat', null);
            await this.$store.dispatch('setmodePaiement', null)
        },

        registerControlThirtStep() {
            if (this.userRegister.genre && this.userRegister.prenom && this.userRegister.nom) {
                return true
            } else return false
        },

        DateDiff(dateItem) {
            let duree = dayjs(new Date()).diff(dateItem, 'day')
            return duree
        },

        //Get all user devis
        async onMyDevis() {
            Api().get("devis/mydevis/" + store.state.user._id)
                .then(response => {
                    this.$store.dispatch('setuser_quote_count', response.data.count);
                }
                );
        },

        //get user contrats
        async getuserContrat() {
            Api().get("contrat/user/" + store.state.user._id)
                .then(response => {
                    this.$store.dispatch('setuser_contract_count', response.data.contrats.length);
                }
                );
        },

        user_has_quote() {
            if (store.state.user_quote_count >= 1) {
                return true
            } else {
                return false
            }
        },

        async User_propertiesforDataLayer(data) {
            PushInDataLayer({

                /*======User data avalaible=========*/
                user_id: data._id,
                user_email: data.email,
                user_phone: data.telephone_port,
                user_city: data.adresse,
                user_registrationDate: data.created,
                user_days_since_registration: this.DateDiff(data.created),
                user_quote_count: store.state.user_quote_count,
                user_contracts_count: store.state.user_contract_count,
                user_has_quote: this.user_has_quote(),

                /*======user data not avalaible=====*/
                user_country: '',
                user_lastVisitDate: '',
                user_days_since_connexion: '',
                user_topBranch1: '',
                user_topBranch2: '',
                user_topBranch3: '',
            })
        },

        resend_new_code() {
            const user = {
                telephone_port: this.userRegister.telephone,
                nom: this.userRegister.nom,
                prenom: this.userRegister.prenom,
            }
            if (this.validation_attemp >= 4) {
                this.$toasted.show("Vous avez dépassé 3 tentatives veuillez réprendre ultérieurement", this.ToastTabError)
                this.$router.push('/')
            } else {
                Api().post('user/resend/newcode', user)
                    .then((result) => {
                        this.resend_code_ctlr = false
                        this.indication = true
                        this.second_counter = 30
                        this.timerInterval = setInterval(this.fetchEventsList, 1000)
                    }).catch((err) => {
                        console.log("=========================================================")
                        this.$toasted.show("Erreur !", this.ToastTabError)
                        console.log("=========================================================")
                    });
            }
            this.validation_attemp = this.validation_attemp + 1
        },

        async user_validation() {
            if (this.account_validation_code) {
                const data = {
                    telephone_port: this.userRegister.telephone,
                    validation_code: this.account_validation_code,
                    email: this.userRegister.email,
                    password: this.userRegister.password,
                    confirmPass: this.userRegister.confirmPass,
                    nom: this.userRegister.nom,
                    prenom: this.userRegister.prenom,
                    role: this.userRole,
                    plateforme: 'Front',
                    code_partenaire: process.env.VUE_APP_CODEP
                }

                Api().post('user/account/validation', data)
                    .then(async result => {
                        if (result.data.modifiedCount == 0) {
                            this.$toasted.show("La validation de votre compte a échoué veuillez réprendre !", this.ToastTabError)
                        } else if (result.data.modifiedCount == 1) {
                            const loginResp = await AuthService.login({
                                login: this.userRegister.email,
                                password: this.userRegister.password,
                                code_partenaire: process.env.VUE_APP_CODEP
                            });

                            if (loginResp.data.error) {
                                this.alert = true;
                                this.message.type = 'error';
                                this.message.texte = loginResp.data.error;
                                this.userLogin.password = ''
                            } else {

                                await this.$store.dispatch('setToken', loginResp.data);
                                await this.$store.dispatch('setUser', loginResp.data);
                                this.userLogin = {};
                                this.LoginDialog = false;
                                this.accountValidationDialog = false
                                await this.$router.push('/')
                            }
                        }
                    }).catch((err) => {
                        this.$toasted.show("Erreur de connexion", this.ToastTabError)
                    });
            } else {
                this.$toasted.show("Le code de validation est obligatoire ", this.ToastTabError)
            }

        },

        /*=============Creation de compte de l'utilisateur ===========*/
        async register() {
            if (this.registerControlThirtStep() == true) {
                if (this.userRegister.password == this.userRegister.confirmPass) {
                    if (this.acceptedCondition != null) {
                        const response = await AuthService.signup({
                            sexe: this.userRegister.genre,
                            email: this.userRegister.email,
                            password: this.userRegister.password,
                            confirmPass: this.userRegister.confirmPass,
                            telephone_port: this.userRegister.telephone,
                            nom: this.userRegister.nom,
                            prenom: this.userRegister.prenom,
                            role: this.userRole,
                            plateforme: 'Front',
                            code_partenaire: process.env.VUE_APP_CODEP,
                            code_parrain: this.code_parrain,
                            created: dayjs(new Date()).format('YYYY-MM-DD')
                        }).then((response) => {
                            
                            if (!response.data.numero) {
                                this.createduser = response.data
                                const val = {
                                    position: this.$loginPopupPosition.position,
                                    event: 'sign_up'
                                }
                                PushInDataLayer(val)

                                if (this.newsletter == true) {
                                    this.checkNewsletter()
                                }


                                if (this.ENV == "prod") {
                                    this.createUserAssurafToBrevo()
                                    //this.MailChimpInscriptionCompte();
                                }
                                this.LoginDialog = false;
                                this.accountValidationDialog = true
                                this.indication = true
                                this.fetchEventsList();
                                this.timerInterval = setInterval(this.fetchEventsList, 1000)

                            } else if (response.data.numero) {
                                this.alert = true;
                                this.message.type = 'error';
                                this.message.texte = response.data.msg
                                setTimeout(() => {
                                    this.alert = false;
                                }, 3000)
                            }
                        }).catch((err) => {
                            console.log("===============error response==============")
                            this.alert = true;
                            this.message.type = 'error';
                            this.message.texte = err.response.data[0].msg
                            setTimeout(() => { this.alert = false; }, 3000)
                        });

                    } else {
                        this.$toasted.show("Veuillez accepter nos conditions conditions pour continuer", this.ToastTabError)
                    }
                } else {
                    this.$toasted.show("Les deux mots de passe doivent être identiques", this.ToastTabError)
                }
            } else {
                this.$toasted.show("Le champs Mr/Mme est obligatoire ", this.ToastTabError)
            }
        },
        /*Fonction de mis en cookies des infos de connexion si user accepte se souvenir de lui*/
        /*Seul l'email est stocké (jamais le mot de passe), avec les attributs Secure + SameSite=Lax*/
        SetCookiesRememberMe(infos) {
            let expires = "";
            const ExpireDate = new Date();
            ExpireDate.setFullYear(ExpireDate.getFullYear() + 1);
            expires = "; expires=" + ExpireDate.toUTCString();
            const ULI_value = encodeURIComponent(infos.email);
            document.cookie = "ULI=" + ULI_value + expires + "; path=/; Secure; SameSite=Lax";
        },

        /*Pré-remplit le champ email depuis le cookie ULI (se souvenir de moi)*/
        prefillEmailFromCookie() {
            const login = document.cookie.match(new RegExp('(^| )ULI=([^;]+)'));
            if (typeof login == 'object' && login != null && login[2]) {
                this.userLogin.email = decodeURIComponent(login[2]);
            }
        },

        /*Supprime le cookie ULI lorsque « se souvenir de moi » est décoché*/
        RemoveRememberMeCookie() {
            document.cookie = "ULI=; Path=/; Max-Age=0";
        },

        /*=============Modification du mot de l'utilisateur ===========*/
        userUpdatePassword: function () {
            if (this.password_new && this.password_new != '') {
                const params = {
                    email: this.password_new,
                };
                Api().post('user/resetpassword', params)
                    .then(response => {
                        this.ServerRep = response.status;
                        this.password_new = ''
                    }).catch(err => {
                        if (err.response.data.message && err.response.data.message) {
                            this.$toasted.show(err.response.data.message, this.ToastTabError)
                        } else {
                            this.$toasted.show("Erreur serveur", this.ToastTabError)
                        }
                    })
            } else {
                this.$toasted.show('Votre adresse email est obligatoire ', this.ToastTabError)
            }
        },

        async createUserAssurafToBrevo () {
            let numberClient = (this.userRegister.countryCode + this.userRegister.telephone).substring(1)
            const response = await AuthService.brevoSaveContact({
                email: this.userRegister.email,
                firstname: this.userRegister.prenom,
                lastname: this.userRegister.nom,
                sms: numberClient,
                address: "Dakar Senegal",
                city: "Dakar",
                country: "Senegal",
                zip: "12000",
                plateforme:"Front",
                phone : numberClient
            }).then((response) => {
                console.log('::::::: ok :::::::::')
            }).catch((error)=> {
                console.log('::::::::: error brevo create user ::::::::::::::', error)
            })

            // const response = await AuthService.brevoSaveContact({
            //     email: "testeunberndebdyebyr@tevte.com",
            //     firstname: "Cheiwoo",
            //     lastname: "Cheiwoo",
            //     sms: numberClient,
            //     address: "Dakar Senegal",
            //     city: "Dakar",
            //     country: "Senegal",
            //     zip: "12000",
            //     plateforme:"Front",
            //     phone : numberClient
            // }).then((response) => {
            //     console.log('::::::: ok :::::::::')
            // }).catch((error)=> {
            //     console.log('::::::::: error brevo create user ::::::::::::::', error)
            // })
        },
        MailChimpInscriptionCompte() {
            let data = {
                "email": this.userRegister.email,
                "FNAME": this.userRegister.prenom,
                "LNAME": this.userRegister.nom,
                "PHONE": this.userRegister.telephone,
            };
            Api().post('testimonial/mailchimp', data)
                .then(resp => {
                    (resp.data)
                })
                .catch(e => {
                    (e)
                })
        },

        async getRoles() {
            const roles = await RoleService.liste();
            const DataRole = roles.data
            for (let roles of DataRole) {
                if (roles.name == "User") {
                    this.userRole = roles._id;
                }
            }
        }

    },

    mounted() {
       
        this.prefillEmailFromCookie()
        this.getListPartner()
        $(document).ready(function () {
            $(".swith-click").click(function () {
                $(".swith-click").removeClass('active');
                $(this).addClass("active");
            });
        });

        this.getRoles()
    }
}

</script>

<style scoped>
@import "../../assets/css/button.css";

.popup-login-title {
    background: #fff;
    color: #ffa409;
    text-align: center !important;
}

.assuraf-color {
    color: #ffa409;
    text-transform: none
}

.georgia {
    /* font-family: Georgia !important; */
    font-family: Lato, "Helvetica Neue", Arial, sans-serif
}

/*================== CSS INUPT LOGIN===================*/
input {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    box-shadow: none;
    background: #fff;
}

select::-ms-expand {
    display: none;
}

select {
    flex: 1;
    padding: 0 .5em;
    color: grey;
    cursor: pointer;
}

.select {
    /*display: flex;*/
    width: 100%;
    height: 3em;
    line-height: 3;
    padding-left: 10px;
    padding-top: -10px;
    background: #fff;
    overflow: hidden;
    border: 2px solid #D3D3D3 !important;
    border-radius: 35px;
}

.border-radius {
    border-radius: 20px !important;
}

.scroll {
    max-height: 450px;
    overflow-y: auto !important;
}

@import url(https://fonts.googleapis.com/css?family=Open+Sans:400italic,400,300,600);

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}


.container {
    width: 100%;
    position: relative;
}

#contact input[type="text"],
#contact input[type="email"],
#contact input[type="password"],
#contact input[type="number"],
#contact button[type="submit"] {
    font: 400 12px/16px "Open Sans", Helvetica, Arial, sans-serif;
    border-radius: 30px;
}

#contact {
    background: #FEB033;
    padding-right: 35px;
    padding-left: 35px;
    border-radius: 20px;
    /* margin:50px 0; */
}

#contact h3 {
    color: #ffa409;
    display: block;
    font-size: 30px;
    font-weight: 400;
}

#contact h4 {
    margin: 5px 0 15px;
    display: block;
    font-size: 13px;
}

fieldset {
    border: medium none !important;
    margin: 0 0 10px;
    min-width: 100%;
    padding: 0;
    width: 100%;
}

#contact input[type="text"],
#contact input[type="email"],
#contact input[type="password"],
#contact input[type="number"],
#contact textarea {
    width: 100%;
    background: #F99B00;
    margin: 0 0 5px;
    padding: 10px;
}

#contact input[type="text"]:hover,
#contact input[type="email"]:hover,
#contact input[type="password"]:hover,
#contact input[type="number"]:hover,
#contact textarea:hover {
    -webkit-transition: border-color 0.3s ease-in-out;
    -moz-transition: border-color 0.3s ease-in-out;
    transition: border-color 0.3s ease-in-out;
    border: 1.5px solid #333;
}

#contact input[type="text"]::placeholder,
#contact input[type="email"]::placeholder,
#contact input[type="password"]::placeholder,
#contact input[type="number"]::placeholder,
#contact textarea::placeholder {
    color: black;
}



#contact button {
    cursor: pointer;
    width: 45%;
    border: none;
    text-transform: none;
    font-weight: bolder !important;
    background: #000000;
    color: #FEB033;
    margin: 0 0 5px;
    padding: 10px;
    border-radius: 8px;
    font: 400 16px/16px "Open Sans", Helvetica, Arial, sans-serif;
}

#contact button:hover {
    background: #FEB033;
    border: 1.5px solid #333;
    color: #000000;
    -webkit-transition: background 0.3s ease-in-out;
    -moz-transition: background 0.3s ease-in-out;
    transition: background-color 0.3s ease-in-out;
}

#contact button[type="submit"]:active {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.5);
    font-weight: bolder
}

#contact input:focus,
#contact textarea:focus {
    outline: 0;
    border: 1px solid #999;
}

::-webkit-input-placeholder {
    color: #888;
}

:-moz-placeholder {
    color: #888;
}

::-moz-placeholder {
    color: #888;
}

:-ms-input-placeholder {
    color: #888;
}

#error {
    color: red;
    font-weight: bold;
    font-family: Lato, "Helvetica Neue", Arial, sans-serif;
    float: left;
    margin-top: -15px;
    margin-left: 12px;


}

.switchbutton.active {
    border-bottom: 0;
    background-color: #FEB033;
    color: #000000;
    text-transform: none;
    padding-top: 10px;
    font-size: 18px;
}

.switchbutton {
    width: auto;
    font-weight: 400;
    background-color: #bf7700;
    border: none;
    outline: none;
    text-transform: none;
}



.tabs {
    padding: 0;
    width: auto;
}

/* The container */
.container-checkbox {
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    display: inline-block;
    position: relative;
    /*padding-left: 35px;*/
    margin-bottom: 10px;
    padding-left: 30px;
    float: left;
    cursor: pointer;
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.container-checkbox .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    float: left;
    height: 15px;
    width: 15px;
    border-radius: 2px;
    background-color: #bf7700;
}

/* On mouse-over, add a grey background color */
.container-checkbox:hover input~.checkmark {
    background-color: rgba(51, 51, 51, 0.47);
}

/* When the checkbox is checked, add a blue background */
.container-checkbox input:checked~.checkmark {
    background-color: #333;
}

/* Create the checkmark/indicator (hidden when not checked) */
.container-checkbox .checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container-checkbox input:checked~.checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container-checkbox .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid #FEB033;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

/* Show the indicator (dot/circle) when checked */
.container-radio input:checked~.checkmark:after {
    display: block;
}


.select-wrapper {
    position: relative;
}

.select-wrapper::after {
    color: black;
    content: '▾';
    margin-right: 10px;
    pointer-events: none;
    position: absolute;
    right: 10px;
    top: 5px;
}

.select {
    -moz-appearance: none;
    -webkit-appearance: none;
    border: none;
    border-radius: 2;
    cursor: pointer;
    padding: 12px;
    width: 100%;
    background: #F99C00;
    color: black;
    font-size: 11px;
    padding-top: 0px !important;
    border: none !important;
}

.select:focus {
    color: black;
}

.select::-ms-expand {
    display: none;
}




.intl_number {
   border-radius: 30px 0 0 30px;
   height: 40px;
   background: #F99B00; 
   color: black;
   margin-top:-5px!important;
   font-size: 14px;

}
.intl_number:hover {
    border: 1.5px solid #000000;
}
.intl_number:focus {
    outline: none;
    border-color: #F99B00 !important;
}
    .intl_number:focus::-webkit-input-placeholder {
        color: #000;
    }
    .intl_number:focus::-moz-placeholder {
        color: #000;
    }
    .intl_number:focus:-ms-input-placeholder {
        color: #000;
    }
    .intl_number:focus::-ms-input-placeholder {
        color: #000;
    }

.intl_number::-webkit-input-placeholder {
    color: #000;
}


.intl_number_mobile {
   border-radius: 30px 0 0 30px;
   height: 36px;
   background: #F99B00; 
   color: black;
   margin-top:-5px!important;
   font-size: 12px;

}
.intl_number_mobile:hover {
    border: 1.5px solid #000000;
}
.intl_number_mobile:focus {
    outline: none;
    border-color: #F99B00 !important;
}
    .intl_number_mobile:focus::-webkit-input-placeholder {
        color: #000;
    }
    .intl_number_mobile:focus::-moz-placeholder {
        color: #000;
    }
    .intl_number_mobile:focus:-ms-input-placeholder {
        color: #000;
    }
    .intl_number_mobile:focus::-ms-input-placeholder {
        color: #000;
    }

.intl_number_mobile::-webkit-input-placeholder {
    color: #000;
}

</style>
